import { useMediaQuery } from '@mui/material';
import { ReactNode } from 'react';
import theme from '@materialTheme';

interface BreakpointProps {
  children: ReactNode;
}

interface MobileProps extends BreakpointProps {
  extendTablet?: boolean;
}

export const MobileBreakpoint = ({ children, extendTablet }: MobileProps) => {
  const isMobile = useMediaQuery(
    extendTablet ? theme.breakpoints.down('md') : theme.breakpoints.down('sm')
  );

  if (!isMobile) {
    return null;
  }

  return <>{children}</>;
};

export const TabletBreakpoint = ({ children }: BreakpointProps) => {
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  if (!isTablet) {
    return null;
  }

  return <>{children}</>;
};

export const DesktopBreakpoint = ({ children }: BreakpointProps) => {
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  if (!isDesktop) {
    return null;
  }

  return <>{children}</>;
};
